import { OnboardingClient } from './onboarding-client';
import { Deserializable } from '../deserializable';
import { OnboardingStep } from './onboarding-step';

export class ClientListResponse implements Deserializable {
  clients: OnboardingClient[];
  steps: OnboardingStep[];

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
